import { Link } from "react-router-dom";
import { Minus, Plus, ShoppingBag } from "lucide-react";
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from "@/components/ui/drawer";
import { imgUrl } from "@/lib/content";
import { useCart } from "@/lib/cart";

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const QtyControl = ({ qty, onChange, testId }) => (
  <span className="qty" data-testid={testId}>
    <button type="button" onClick={() => onChange(qty - 1)} aria-label="Decrease quantity" data-testid={`${testId}-minus`}><Minus size={14} /></button>
    <b data-testid={`${testId}-value`}>{qty}</b>
    <button type="button" onClick={() => onChange(qty + 1)} aria-label="Increase quantity" data-testid={`${testId}-plus`}><Plus size={14} /></button>
  </span>
);

export const CartLines = ({ editable = true }) => {
  const cart = useCart();
  return (
    <div className="cart-lines" data-testid="cart-lines">
      {cart.items.map((i) => (
        <div className="cart-line" key={i.id} data-testid={`cart-line-${i.id}`}>
          {i.image ? <img src={imgUrl(i.image, 120)} alt="" /> : <span />}
          <div className="cart-line-info"><small>{i.brand}</small><strong>{i.name}</strong><span>{money(i.price)} each</span></div>
          <div className="cart-line-end">
            {editable ? <QtyControl qty={i.qty} onChange={(q) => cart.setQty(i.id, q)} testId={`cart-qty-${i.id}`} /> : <span>× {i.qty}</span>}
            <b>{money(i.price * i.qty)}</b>
          </div>
        </div>
      ))}
    </div>
  );
};

export const CartButton = ({ onClick }) => {
  const { count, total } = useCart();
  if (!count) return null;
  return (
    <button type="button" className="cart-fab" onClick={onClick} data-testid="cart-open-button">
      <ShoppingBag size={17} /> <span data-testid="cart-count">{count}</span> · {money(total)}
    </button>
  );
};

export const CartDrawer = ({ open, onClose }) => {
  const cart = useCart();
  return (
    <Drawer open={open} onOpenChange={(o) => !o && onClose()} shouldScaleBackground={false}>
      <DrawerContent className="sheet" data-testid="cart-drawer">
        <div className="cart-inner">
          <DrawerTitle className="sheet-title">Your bag</DrawerTitle>
          <DrawerDescription className="sheet-desc">Pick up at the spa at The Marathon Mall.</DrawerDescription>
          {cart.count ? (
            <>
              <CartLines />
              <p className="cart-total" data-testid="cart-total"><span>Total</span><b>{money(cart.total)}</b></p>
              <Link to="/checkout" className="btn gold" onClick={onClose} data-testid="cart-checkout-button">Checkout</Link>
            </>
          ) : <p className="muted-sm" data-testid="cart-empty">Your bag is empty.</p>}
        </div>
      </DrawerContent>
    </Drawer>
  );
};
